import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { MatCardModule } from '@angular/material/card';

@Component({
    selector: 'app-signout',
    templateUrl: './signout.component.html',
    styleUrls: ['./signout.component.css'],
    imports: [
        MatCardModule,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignoutComponent {

  constructor(
    private auth: AuthService
  ) {
    this.auth.signOut();
   }
}
